import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../img/ast_ylw_logo.png';
import defaultAvatar from '../img/profile.png';
import "./Header.css";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [username, setUsername] = useState('');
  const [userImage, setUserImage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userString = localStorage.getItem('user');

    if (token && userString) {
      try {
        const user = JSON.parse(userString);
        setUsername(user.name || user.email || 'User');
        setUserImage(user.image || '');
      } catch {
        setUsername('User');
        setUserImage('');
      }
    } else {
      setUsername('');
      setUserImage('');
    }
  }, [location]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);
  
  const isActive = (path) => location.pathname === path;

  const handleNavigation = (path) => {
    navigate(path);
    closeMenu();
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUsername('');
    setUserImage('');
    setIsProfileMenuOpen(false);
    navigate('/login');
  };

  const navItems = [
    // { label: 'Home', path: '/' },
    // { label: 'Gallery', path: '/events' },
    // { label: 'About Us', path: '/about-us' },
    // { label: 'Contact Us', path: '/contact-us' },
  ];

  return (
    <header className="simple-header">
      <nav className="header-container">
        {/* Logo */}
        <div className="logo-container">
          <img 
            src={logo} 
            alt="Logo" 
            className="header-logo"
            onClick={() => handleNavigation('/')}
            style={{ cursor: 'pointer' }}
          />
        </div>

        {/* Desktop Navigation */}
        <div className="nav-links d-none d-lg-flex">
          {navItems.map((item) => (
            <button
              key={item.path}
              className={`nav-link-btn ${isActive(item.path) ? 'active-link' : ''}`}
              onClick={() => handleNavigation(item.path)}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* Desktop Profile/Login */}
        <div className="profile-container d-none d-lg-flex">
          {username ? (
            <div 
              className="profile-wrapper"
              onMouseEnter={() => setIsProfileMenuOpen(true)}
              onMouseLeave={() => setIsProfileMenuOpen(false)}
            >
              <div
                onClick={() => handleNavigation('/profile')}
                title={`Logged in as ${username}`}
                style={{ cursor: 'pointer' }}
              >
                <img
                  src={userImage || defaultAvatar}
                  alt="Profile"
                  className="profile-img"
                />
              </div>
              
              {isProfileMenuOpen && (
                <div className="profile-dropdown">
                  <button
                    className="logout-btn"
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : !isActive('/login') && !isActive('/signup') && (
            <button
              className="btn btn-primary login-btn"
              onClick={() => handleNavigation('/login')}
            >
              Login
            </button>
          )}
        </div>

        {/* Mobile Hamburger */}
        <button 
          className="hamburger-btn d-lg-none"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {isMenuOpen ? (
              <>
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </>
            ) : (
              <>
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </>
            )}
          </svg>
        </button>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="mobile-nav">
          {navItems.map((item) => (
            <button
              key={item.path}
              className={`nav-link-btn ${isActive(item.path) ? 'active-link' : ''}`}
              onClick={() => handleNavigation(item.path)}
            >
              {item.label}
            </button>
          ))}

          {/* Mobile Profile/Login */}
          {/* Mobile Profile/Login */}
          <div className="mobile-profile-section">
            {username ? (
              <>
                <div 
                  className="mobile-profile"
                  onClick={() => handleNavigation('/profile')}
                >
                  <img
                    src={userImage || defaultAvatar}
                    alt="Profile"
                    className="profile-img"
                  />
                  <span className="ms-2">{username}</span>
                </div>
                <button
                  className="btn btn-danger w-100 mt-2"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </>
            ) : !isActive('/login') && !isActive('/signup') && (
              <button
                className="btn btn-primary w-100"
                onClick={() => handleNavigation('/login')}
              >
                Login
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;